import styled from "styled-components";

export const SocialStyled =styled.div`
display: flex;
align-items: center;
justify-content: center;
li{
    list-style-type: none;
}
a{
    border: 1px solid #fff;
    border-radius: 50%;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    width: 40px;
    height: 40px;
    text-decoration: none;
}
`